// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"P3uCA","color":"-Aqu5","swatch":"_9jg-Y","popover":"J4sBO","cover":"JECJG","label":"dbO9l"};